export default {
	title: 'HSWS Test',
	library: {
		name: 'Logan City Council Libraries',
		homepage: 'https://loganlibraries.org',
		catalogue: 'https://logan.bibliocommons.com'
	},
	hsws: {
		baseUrl: 'https://services.libraries.logan.qld.gov.au/hzws/',
		clientId: 'SymWSTestClient',
		originatingAppId: 'HaveIBorrowed'
	},
	dataAge: {
		// this is how old the data has to be before it is allowed to be refreshed.
		// basically stops the server from being constantly hammered,
		// espcailly since most of the data is slow changing.
		// there are two properties in each object:
		// 	* automatic - used when pages are loaded
		//	* manual - used for pull to refresh or clicking the refresh button
		// each propery is an object that Moment.js will use
		user: {
			// this is typically superslow changing
			automatic: {
				days: 14
			},
			manual: 0
		},
		itemsOut: {
			automatic: {
				hours: 12
			},
			manual: 0
		},
		itemsOnHold: {
			automatic: {
				hours: 12
			},
			manual: 0
		}
	}
}